import { Media } from 'enums';
import { IMediaQuery, IMediaMatchList } from '../useMediaQuery.model';

const queries = Object.entries(Media);
export const getMediaQueries: () => IMediaMatchList = () =>
  queries.reduce(
    (acc, [key, query]) => ({ ...acc, [key]: matchMedia(query) }),
    {},
  );

export const getMatches: () => IMediaQuery = () =>
  Object.entries(getMediaQueries()).reduce(
    (acc, [key, matchList]) => ({
      ...acc,
      [key]: matchList.matches,
    }),
    {},
  );

export const processResult = (values: IMediaQuery) =>
  Object.entries(values).reduce((result, [key, value], idx, arr) => {
    const [, theNextItem] = arr[idx + 1] || [];

    return { ...result, [key]: theNextItem ? false : value };
  }, {});
